import { Task } from '@/api';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import styles from './mini-task-item.module.scss';
import { UIAvatar, UIText } from '@/ui';
import { TaskStatusIndicator } from './task-status-indicator';
import { useTasksTranslation } from '../hooks';

export type MiniTaskItemProps = {
    task: Task;
    onClick?: () => void;
};

export function MiniTaskItem(props: MiniTaskItemProps): ReactElement {
    const { task, onClick } = props;
    const { t } = useTasksTranslation();
    const navigate = useNavigate();

    return (
        <button className={styles.container} onClick={onClick}>
            <UIAvatar
                img={task.displayInfo.image}
                alt={task.displayInfo.name}
                subAvatar={
                    task.displayInfo.subImage
                        ? {
                              img: task.displayInfo.subImage,
                              alt: task.displayInfo.subText ?? ''
                          }
                        : undefined
                }
            />
            <div className={styles.textContainer}>
                <UIText medium>{task.title}</UIText>
                <UIText>{task.displayInfo.name}</UIText>
                {task.team.deleted ? (
                    <UIText>{t('shared.tasks.deleted_team')}</UIText>
                ) : (
                    <div
                        role="link"
                        onClick={(e) => {
                            e.stopPropagation();
                            void navigate(
                                `/company/${task.companyId}/settings/teams/${task.team.id}`
                            );
                        }}
                        style={{
                            display: 'flex',
                            gap: 4,
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 4,
                            cursor: 'pointer'
                        }}
                    >
                        <UIAvatar
                            img={task.team.image ?? ''}
                            alt={task.team.name ?? ''}
                            size={18}
                        />
                        <UIText variant="small" type="link" underlineOnHover>
                            {task.team.name}
                        </UIText>
                    </div>
                )}
            </div>
            <TaskStatusIndicator task={task} />
        </button>
    );
}
